"use client";

import { useTranslation } from "react-i18next";

import EscapeRoomDetails from "@/components/escape-room-details/escape-room-details";

const DetailsPageClient = ({ url }: { url: string }) => {
    const { t } = useTranslation();

    const raw = t("escaperooms", {
        returnObjects: true,
        interpolation: {
            skipOnVariables: false,
        },
    });

    const escapeRoomsData = Array.isArray(raw) ? raw : [];

    const room = escapeRoomsData.find((r) => r.url === url);

    if (!room) {
        return (
            <div className="details-screen desktop">
                <h1>{t("details.notFound")}</h1>
                <a href="/">{t("details.back")}</a>
            </div>
        );
    }

    return <EscapeRoomDetails room={room} />;
};

export default DetailsPageClient;
